import React from "react";

const CalendarPage = () => {
    return (
        <div>
            <h2>Календарь</h2>
            <p>Тут будет календарь.</p>
        </div>
    );
};

export default CalendarPage;